import Component from '../../js/_Component';

export default class BoatDesignYours extends Component {
	constructor(element: HTMLElement) {
		super(element);

		// Adjust carousel to be left align if only one boat
		const slides = this.element.querySelectorAll('.c-carousel--item');
		if (slides.length === 1) {
			this.element.querySelector('.c-carousel').classList.add('align-left');
		}
	}
}

Component.register(BoatDesignYours, 'BoatDesignYours');
